// components
import AppointmentForm from './AppointmentForm';

// hooks
import { useNarrowedShortcutContexts } from 'components/shared/ShortcutProvider/ShortcutProvider.hooks';

// stores
import { useAppointmentStore } from 'components/mrp/stores/appointmentStore/appointmentStore';
import { GLOBAL_CONTEXT } from 'components/shared/ShortcutProvider/ShortcutProvider.consts';

// utils
import { useShallow } from 'zustand/shallow';
import { Activity } from 'react';

const AppointmentFormVisibility = () => {
  const appointment = useAppointmentStore(
    useShallow((state) => state.appointment)
  );

  useNarrowedShortcutContexts(!!appointment, [GLOBAL_CONTEXT]);

  return (
    <Activity mode={!!appointment ? 'visible' : 'hidden'}>
      <AppointmentForm key={appointment?.id} />
    </Activity>
  );
};

export default AppointmentFormVisibility;
